exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "upload-avatar-open label{position:relative;color:#fff;cursor:pointer}upload-avatar-open label:before{content:\"Zmie\\144   avatar\";width:100%;position:absolute;left:0;right:0;border-bottom:1px solid #fff;padding:5px;transition:all .3s;bottom:0;text-align:center}upload-avatar-open label:hover:before,upload-avatar-open label:hover figure{display:block}upload-avatar-open figure{position:absolute;top:0;width:100%;height:100%;padding:40px;margin:0 auto 10px;transition:all .3s;background-color:rgba(0,0,0,.3)}upload-avatar-open figure,upload-avatar-open label:before{display:none}upload-avatar-open figure,upload-avatar-open img{border-radius:5px}upload-avatar-open input{display:none!important}upload-avatar-open svg{width:100%;height:100%;fill:#fff}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/utility/upload-avatar/upload-avatar.styl
 ** module id = 269
 ** module chunks = 0
 **/